import Vue from 'vue'
import VueRouter from 'vue-router'
import Home  from'../views/Home.vue'
import Usuario from'../components/Usuario.vue'
import Recibo from'../components/Recibo.vue'
import Login from '../components/Login.vue'


import AprobacionTransferencia from '../components/AprobacionTransferencia.vue'
import AprobacionRecibo from '../components/AprobacionRecibo.vue'
import Cobranza from '../components/Cobranza.vue'
import Banco from '../components/Banco.vue'
import MetodoPagoView from '../views/MetodoPagoView.vue'
import Prueba from '../components/Prueba.vue'
import Talonario from '../components/Talonario.vue'
import Cliente from '../views/ClienteView.vue'

import store from '../store/index.js'
import KardexBonosView from '../views/KardexBonosView.vue'
import KardexTerbolBonosView from '../views/KardexTerbolBonosView.vue'
import BancarizacionView from '../views/BancarizacionView.vue'
import decode from 'jwt-decode'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:true,      
      repartidor:true
    }
  },
   
  
  {
    path: '/Usuario',
    name: 'Usuario',
    component: Usuario,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false
    }
  }, 
  
  {
    path: '/Recibo',
    name: 'Recibo',
    component: Recibo,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:true,
      repartidor:true
    }
  }, 
  
  
  
   
  

  
   
   
   {
    path: '/Cliente',
    name: 'Cliente',
    component: Cliente,
    meta:{
      administrador:true,
      encargado:false,
      cobrador:true,  
      repartidor:true   
    }
  }, 
   {
    path: '/AprobacionTransferencia',
    name: 'AprobacionTransferencia',
    component: AprobacionTransferencia,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false   

    }
  }, 
   {
    path: '/AprobacionRecibo',
    name: 'AprobacionRecibo',
    component: AprobacionRecibo,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false
      
    }
  }, 
  {
    path: '/Banco',
    name: 'Banco',
    component: Banco,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false
      
    }
  }, 
  {
    path: '/Prueba',
    name: 'Prueba',
    component: Prueba,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false
      
    }
  }, 
  {
    path: '/ReporteMetodoPago',
    name: 'MetodoPagoView',
    component: MetodoPagoView,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false
      
    }
  }, 
  {
    path: '/KardexBonos',
    name: 'KardexBonosView',
    component: KardexBonosView,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:true,
      repartidor:false
      
    }
  }, 
  {
    path: '/KardexTerbolBonos',
    name: 'KardexTerbolBonosView',
    component: KardexTerbolBonosView,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:true,
      repartidor:false
      
    }
  }, 
  {
    path: '/Bancarizacion',
    name: 'BancarizacionView',
    component: BancarizacionView,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false
      
    }
  }, 
   {
    path: '/Talonario',
    name: 'Talonario',
    component: Talonario,
    meta:{
      administrador:true,
      encargado:true,
      cobrador:false,
      repartidor:false
    }
  }, 
   
   {
    path: '/Cobranza',
    name: 'Cobranza',
    component: Cobranza,
    meta:{
      administrador:true,
      encargado:false,
      cobrador:false,
      repartidor:false
      
      
    }
  }, 
   
  
  
  

  
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta:{      
      libre:true
    }
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: Login, // Reutilizamos el componente Login para manejar el callback
    meta:{      
      libre:true
    }
  },  

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach((to) => {
  gtag('config', 'G-BT5733VG9J', {
  page_path: to.fullPath,
    app_name: 'Cobranzas',
    send_page_view: true,
  });
});

router.beforeEach((to, from, next) => {
  // Verificar si la ruta es libre (no requiere autenticación)
  if (to.matched.some(record => record.meta.libre)){
    next()
    return
  }
  
  // Si ya estamos en login, evitar bucles
  if (to.name === 'Login') {
    next()
    return
  }
  
  // Verificar si el usuario está autenticado
  if (!store.state.usuario || !store.state.token) {
    // Intentar autologin antes de redirigir
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = decode(token);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp > currentTime) {
          // Token válido, actualizar store
          store.commit("setToken", token);
          store.commit("setUsuario", decodedToken);
          // Ahora verificar permisos con el usuario actualizado
          checkPermissions(to, next, decodedToken.rol);
          return;
        } else {
          // Token expirado
          localStorage.removeItem("token");
          next({ name: 'Login' });
          return;
        }
      } catch (error) {
        // Token inválido
        localStorage.removeItem("token");
        next({ name: 'Login' });
        return;
      }
    } else {
      next({ name: 'Login' });
      return;
    }
  }
  
  // Usuario autenticado, verificar permisos por rol
  checkPermissions(to, next, store.state.usuario.rol);
})

function checkPermissions(to, next, userRole) {
  if (userRole === 'ADM'){
    if (to.matched.some(record => record.meta.administrador)){
      next()
    } else {
      next({ name: 'Home' })
    }
  } else if (userRole === 'ENC'){
    if (to.matched.some(record => record.meta.encargado)){
      next()
    } else {
      next({ name: 'Home' })
    }
  } else if (userRole === 'COB'){
    if (to.matched.some(record => record.meta.cobrador)){
      next()
    } else {
      next({ name: 'Home' })
    }
  } else if (userRole === 'REP'){
    if (to.matched.some(record => record.meta.repartidor)){
      next()
    } else {
      next({ name: 'Home' })
    }
  } else {
    next({ name: 'Login' })
  }
}

export default router
